const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';

function toggleSideBar(open){
    return {
        type : TOGGLE_SIDEBAR,
        open : open
    }
}

export {
    TOGGLE_SIDEBAR,
    toggleSideBar
}